import { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'
import { omit } from 'lodash/fp'

import { getTasksGroupedByNode } from 'Automations/automationExecutions/overview/getAllTasksGroupedByNode'
import { AutomationExecution } from 'Automations/automationExecutions/types'
import { useResolvedNodeDefinitions } from 'Automations/nodeDefinitions'

const NO_REVIEWABLE_TASKS: Dashboardv99990101Api.Automations.ManualTask[] = []

export const RenderNode = ({
  node,
  automationExecution,
  isLatestNodeExecution,
  reviewableTasks = NO_REVIEWABLE_TASKS
}: {
  node: ReturnType<typeof getTasksGroupedByNode>[number]
  automationExecution: AutomationExecution
  isLatestNodeExecution: boolean
  reviewableTasks?: Dashboardv99990101Api.Automations.ManualTask[]
}) => {
  const ExecutionSummaryComponent =
    useResolvedNodeDefinitions()[node.nodeType]?.executionSummary
  if (!ExecutionSummaryComponent) {
    return null
  }

  return (
    <ExecutionSummaryComponent
      tasks={node.tasks}
      automationExecution={
        omit(['tasks'])(automationExecution) as Omit<
          AutomationExecution,
          'tasks'
        >
      }
      isLatestNodeExecution={isLatestNodeExecution}
      reviewableTasks={reviewableTasks}
    />
  )
}
